import { Link } from "react-router-dom";
import { featuredComic } from "@/mocks/comics";

export default function Spotlight() {
  const tags = ["热血", "校园", "黑手党", "战斗", "搞笑", "经典"];
  const stats = [
    { value: "20", label: "话试读章节" },
    { value: "409", label: "原著话数" },
    { value: "9.6", label: "评分" },
    { value: "3.2亿", label: "人气" },
  ];

  return (
    <section className="relative overflow-hidden bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          {/* Cover */}
          <div className="relative mx-auto w-full max-w-sm">
            <div className="absolute -inset-3 rounded-lg bg-primary-500/10" />
            <Link to={`/manga/${featuredComic.id}`} className="relative block overflow-hidden rounded-lg" aria-label={`查看漫画《${featuredComic.title}》详情`}>
              <img
                src={featuredComic.cover}
                alt={`${featuredComic.title}漫画封面`}
                title={`${featuredComic.title}漫画在线免费阅读-178漫画网`}
                className="w-full rounded-lg object-cover object-top"
              />
              <span className="absolute left-3 top-3 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
                本站力荐
              </span>
            </Link>
          </div>

          {/* Intro */}
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-star-fill" aria-hidden="true" /> 编辑精选
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">{featuredComic.title}</h2>
            <p className="mt-2 text-sm text-foreground-700">
              作者：{featuredComic.author} · {featuredComic.status} · 更新于 {featuredComic.updatedAt}
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-800 md:text-base md:leading-8">
              {featuredComic.description}
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              {tags.map((t) => (
                <Link
                  key={t}
                  to="/category/all"
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  #{t}
                </Link>
              ))}
            </div>

            <div className="mt-7 grid grid-cols-4 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="flex flex-col items-center gap-1 rounded-lg bg-background-50 px-2 py-3">
                  <span className="font-heading text-lg font-black text-primary-600 md:text-xl">{s.value}</span>
                  <span className="text-xs text-foreground-600">{s.label}</span>
                </div>
              ))}
            </div>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <Link
                to={`/read/${featuredComic.id}/${featuredComic.chapters[0].id}`}
                className="flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-fill" aria-hidden="true" />
                开始阅读
              </Link>
              <Link
                to={`/manga/${featuredComic.id}`}
                className="flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-bold text-foreground-950 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                查看全部章节
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}